<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-信息公开">
    <div class="swipe">
      <img src="http://123.56.170.62:9999/static/bg/banner4.png" alt />
      <!-- <img src="../assets/banner10.png" alt /> -->
    </div>
    <Class :nav="nav"></Class>
  </div>
</template>
<script>
import Class from "@/components/Class.vue"
import Bus from "@/utils/bus.js"
export default {
  data() {
    return {
      nav: [
        { title: "政策法规", url: "zcfg" },
        { title: "管理制度", url: "glzd" },
        { title: "年审结果", url: "ndbg" },
        { title: "审计报告", url: "sjbg" },
        { title: "信息公告", url: "xxgg" },
      ],
    }
  },
  mounted() {
    this.$nextTick(function() {
      Bus.$emit("getCurrent", "newsInfo")
    })
  },
  methods: {},
  components: {
    Class,
  },
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
}
</style>
